import React from "react";
import { Grid, IconButton, Menu, type IconButtonProps, type PopoverProps, type SvgIconProps } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { useMenuState } from "../hooks";

export interface ContextMenuProps {
	/**
	 * The content of the context menu. Should be a list of MUI `MenuItem` components.
	 */
	readonly children: React.ReactNode;
	readonly iconButtonProps?: Omit<IconButtonProps, "onClick">;
	readonly popoverProps?: Omit<PopoverProps, "open">;
	readonly Icon?: React.ReactElement<SvgIconProps>;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({ Icon, children, iconButtonProps, popoverProps }) => {
	const { anchorEl, open, handleOpen, handleClose, handleMenuItemClick } = useMenuState();

	return (
		<Grid container spacing={2} justifyContent="flex-end">
			<IconButton
				onClick={handleOpen}
				{...iconButtonProps}
				data-testid="context-menu-button"
				sx={{
					backgroundColor: open ? "action.selected" : undefined,
					...iconButtonProps?.sx,
				}}
			>
				{Boolean(Icon) && Icon}
				{Boolean(Icon) === false && <MoreVertIcon data-testid="more-vert-icon" />}
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				onClick={handleMenuItemClick}
				{...popoverProps}
				data-testid="context-menu"
			>
				{children}
			</Menu>
		</Grid>
	);
};
